import React from 'react';
import Layout from '../layouts/six';
import Title from '../partials/title';
import ScrollAnimation from 'react-animate-on-scroll';

const Covid = () => {
    return (
        <Layout nbs="a" title="" bi="/images/backgrounds/covid.jpg">
            <section>
                <div className="w3-white">
                    <div style={{ height: 20 }} />
                    <ScrollAnimation animateIn="fadeInLeft" animateOnce={true} className="d-flex flex-row w3-container w3-content pb-8 pt-8" >
                        <div className="w-100 d-flex flex-column justify-content-start">
                            <Title text="Challenge Sports Safety Procedures" />
                            <p className="gray hind margin-top">Challenge Sports takes the safety and wellbeing of its members very seriously. We are following the current CDC guidelines at all of our events. By participating in our events you acknowledge that there are certain risks involved and by doing so you will not hold Challenge Sports responsable and indemnify them in any way. It is our goal to provide all our participants a safe and fun environment and do everything we can to achieve that. We ask that all of our participants be considerate of each other and respect the protocols that our Governor and the CDC have put in place.</p>
                        </div>
                        <div style={{ width: 40 }} />
                        <div className="w-100">
                            <img alt="" className="w-100" src="/images/others/celebrating.png" />
                        </div>
                    </ScrollAnimation>
                </div>
                {/*<div className="bg-whiteish">

                    <h4 className="pt-4 text-center">Please download and print</h4>

                    <div className="d-flex flex-row w3-container w3-content pb-8 pt-8">
                        <div className="w-100 text-center d-flex flex-column">
                            <a className="black" href="/waivers/Challenge_Sports_Social_Distance_Rules.pdf" target="_blank" rel="noopener noreferrer">
                                <i className="fas fa-file-signature font-60"></i>
                                <h4 className="mt-2 font-20">Challenge Sports Social Distancing Rules</h4>
                            </a>
                        </div>
                        <div style={{ width: 120 }} />
                        <div className="w-100 text-center d-flex flex-column">
                            <a className="black" href="/waivers/Challenge_Sports_COMMUNICABLE_DISEASE_WAIVER_v3.pdf" target="_blank" rel="noopener noreferrer">
                                <i className="fas fa-file-signature font-60"></i>
                                <h4 className="mt-2 font-20">Challenge Sports Communicable Disease Waiver</h4>
                            </a>
                        </div>
                        <div style={{ width: 120 }} />
                        <div className="w-100 text-center d-flex flex-column">
                            <a className="black" href="/waivers/Palm_Coast_&_Challenge_Sports_COMMUNICABLE_DISEASE_WAIVER.pdf" target="_blank" rel="noopener noreferrer">
                                <i className="fas fa-file-signature font-60"></i>
                                <h4 className="mt-2 font-20">Palm Coast - Challenge Sports Communicable Disease Waiver</h4>
                            </a>
    </div>

                    </div>
    </div>*/}
            </section>
        </Layout>
    );
}

export default Covid;



// WEBPACK FOOTER //
// ./src/components/covid/index.js